// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailAppUnit_wrapper__TG+O8","col":"DetailAppUnit_col__20aC6"};